/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Descriptor, { IDescriptorBody } from './../../descriptor';

import Comment, { IComment, ICommentJSON } from './commentdescriptor';

interface ICommonThread {
	commentThreadId: string;
	resolvedBy?: string | null;
}

export interface IThreadJSON extends ICommonThread {
	comments?: ICommentJSON[];
	attributes?: string | null;
	createdAt?: string;
	deletedAt?: string | null;
	resolvedAt?: string | null;
	context?: string | null;
	unlinkedAt?: string | null;
}

export interface IThread extends ICommonThread {
	comments?: IComment[];
	createdAt?: Date;
	deletedAt?: Date | null;
	resolvedAt?: Date | null;
	attributes?: Record<string, unknown> | null;
	context?: Record<string, unknown> | null;
	unlinkedAt?: Date | null;
}

export default class CommentsThreadDescriptor extends Descriptor {
	public static readonly DESCRIPTOR_NAME: string = 'CommentsThreadDescriptor';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			comments: {
				type: 'CommentDescriptor',
				rule: 'repeated',
				id: 2
			},
			resolvedAt: {
				type: 'string',
				id: 3
			},
			resolvedBy: {
				type: 'string',
				id: 4
			},
			context: {
				type: 'string',
				id: 5
			},
			createdAt: {
				type: 'string',
				id: 6
			},
			deletedAt: {
				type: 'string',
				id: 7
			},
			attributes: {
				type: 'string',
				id: 8
			},
			unlinkedAt: {
				type: 'string',
				id: 9
			}
		}
	};

	public static toJSON( thread: IThread ): IThreadJSON {
		return {
			...thread,
			createdAt: thread.createdAt?.toISOString(),
			deletedAt: thread.deletedAt?.toISOString(),
			resolvedAt: thread.resolvedAt?.toISOString(),
			attributes: thread.attributes ? JSON.stringify( thread.attributes ) : null,
			context: thread.context ? JSON.stringify( thread.context ) : thread.context,
			comments: thread.comments?.map( Comment.toJSON ),
			unlinkedAt: thread.unlinkedAt?.toISOString()
		};
	}

	public static fromJSON( thread: IThreadJSON ): IThread {
		return {
			...thread,
			createdAt: thread.createdAt ? new Date( thread.createdAt ) : undefined,
			deletedAt: thread.deletedAt ? new Date( thread.deletedAt ) : undefined,
			resolvedAt: thread.resolvedAt ? new Date( thread.resolvedAt ) : undefined,
			attributes: thread.attributes ? JSON.parse( thread.attributes ) : null,
			context: thread.context ? JSON.parse( thread.context ) : undefined,
			comments: thread.comments?.map( Comment.fromJSON ),
			unlinkedAt: thread.unlinkedAt ? new Date( thread.unlinkedAt ) : undefined
		};
	}
}
